import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import { Field } from "formik";
import { commonInputGroupStyles } from "..";
import _ from "lodash";
import jssVariables from "../../../../jss_setup";

const styles = createUseStyles({
  inputGroup: (props) => ({
    ...commonInputGroupStyles.inputGroup,
    gridTemplateRows: "max-content 2.3rem",
    alignItems: "center",
    ..._.get(props, "customStyles.inputGroup", {}),
  }),
  label: (props) => ({
    ...commonInputGroupStyles.label,
    fontSize: "medium",
    ...(props?.customStyles?.label ?? {}),
  }),
  switch: (props) => ({
    position: "relative",
    display: "inline-block",
    width: "60px",
    height: "34px",
    ..._.get(props, "customStyles.switch", {}),
  }),
  slider: (props) => ({
    position: "absolute",
    cursor: "pointer",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: props.checked ? props.checkedColor : "#ccc",
    [`-webkit-transition`]: ".4s",
    transition: ".4s",
    borderRadius: "34px",
    "&:before": {
      content: `""`,
      position: "absolute",
      height: "26px",
      width: "26px",
      left: "4px",
      bottom: "4px",
      backgroundColor: "white",
      borderRadius: "50%",
      transition: ".4s",
      [`-webkit-transition`]: ".4s",
      [`-webkit-transform`]: `translateX(${props.checked ? "26px" : "0px"})`,
      [`-ms-transform`]: `translateX(${props.checked ? "26px" : "0px"})`,
      transform: `translateX(${props.checked ? "26px" : "0px"})`,
    },
    ..._.get(props, "customStyles.slider", {}),
  }),
  input: {
    display: "none",
  },
});
const Toggle = ({ name, label, customStyles, id }) => {
  const [checked, setChecked] = useState(false);
  const classes = styles({
    customStyles,
    checked,
    checkedColor:
      customStyles?.checkbox?.checkedColor ?? jssVariables.colors.base_color,
  });

  return (
    <div className={classes.inputGroup} id={id}>
      <label className={classes.label}>{label}</label>
      <label className={classes.switch}>
        <Field name={name} className={classes.input}>
          {({ field, form: { setFieldValue } }) => {
            return (
              <input
                type="checkbox"
                className={classes.input}
                onChange={() => {
                  setChecked(!field.value);
                  setFieldValue(field.name, !field.value);
                }}
              />
            );
          }}
        </Field>
        <span className={classes.slider}></span>
      </label>
    </div>
  );
};
Toggle.defaultProps = {
  label: "",
  name: "",
  customStyles: {},
  id: "",
};
Toggle.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  customStyles: PropTypes.object,
  id: PropTypes.string,
};
export default Toggle;
